/**
 * Reveal — fade + rise entrance animation, snappy version.
 *
 * Le delay est plafonné à 200 ms total quel que soit le delay passé en prop —
 * évite l'effet « ça charge en cascade » quand la grille a 10+ tuiles.
 *
 * `prefers-reduced-motion` est respecté (animation désactivée).
 */
import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

export function Reveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  const prefersReduced = useReducedMotion();
  if (prefersReduced) {
    return <div className={className}>{children}</div>;
  }
  // Cap delay at 200ms total so big grids don't feel laggy.
  const cappedDelay = Math.min(delay, 0.2);
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: cappedDelay, duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
